import script from "./QuickpaySettingsPitch.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuickpaySettingsPitch.vue?vue&type=script&setup=true&lang=ts"

import "./QuickpaySettingsPitch.vue?vue&type=style&index=0&id=cdf89e5c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdf89e5c"]])

export default __exports__